import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { sessionActions } from '@app/store/session/actions/session.actions';
import { profileActions } from '../actions/profile.actions';

/** `session` already fetched `me`; the profile takes the user from that response instead of asking again. */
@Injectable()
export class ProfileSessionBridge {
    private readonly actions = inject(Actions);

    getProfileSuccess$ = createEffect(() => {
        return this.actions.pipe(
            ofType(sessionActions.getSessionSuccess),
            map(({ payload }) => profileActions.getProfileSuccess({ payload })),
        );
    });
}
